import { Button } from "@/components/ui/button";
import { Layers, Plus, Upload } from "lucide-react";

/**
 * EntregasHeader — Cabeçalho da página Entregas com título + ações principais.
 * Botões (Importar / Lote / Nova Entrega) são gated pelo `canCreate` (matriz `entregas.i`)
 * pra evitar clique que resultaria em 403 do backend.
 *
 * Extraído de Entregas.jsx (fev/2026) — puro/apresentacional, testável em isolamento.
 */
export function EntregasHeader({ canCreate, onImport, onLote, onNova }) {
  return (
    <div className="flex justify-between items-center flex-wrap gap-3">
      <div>
        <h1 className="text-3xl sm:text-4xl font-extrabold">Entregas</h1>
        <p className="text-muted-foreground text-sm">Lançamentos e controle de status</p>
      </div>
      {canCreate && (
        <div className="flex gap-2">
          <Button
            data-testid="btn-import"
            onClick={onImport}
            variant="outline"
            className="border-emerald-600 text-emerald-700 hover:bg-emerald-50"
          >
            <Upload className="w-4 h-4 mr-2" />Importar
          </Button>
          <Button
            data-testid="btn-lote"
            onClick={onLote}
            variant="outline"
            className="border-orange-600 text-orange-700 hover:bg-orange-50"
          >
            <Layers className="w-4 h-4 mr-2" />Lote
          </Button>
          <Button
            data-testid="btn-nova-entrega"
            onClick={onNova}
            className="bg-orange-600 hover:bg-orange-700"
          >
            <Plus className="w-4 h-4 mr-2" />Nova Entrega
          </Button>
        </div>
      )}
    </div>
  );
}
